import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages} from "../../../../Helpers/ErrorMessages";
import PageTitle from "../../../Utils/smsTitle";
import {SubHeader} from "../../../../Containers/SubHeader";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import {RecordedTriage} from "./RecordedTriage";
import RecordTriage from "./RecordTriage";
import Card from "@material-ui/core/Card";
import CustomDialog from "../../../Utils/Dialogs/CustomDialog";




const GynAndObsTriage = ({actions, snackbar, match:{params}}) => {
    // get the doctor's name
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;

    const {patient_number, visit_id, patient_type} = params
    const [patientTriage, setPatientTriage] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [openDialog, setOpenDialog] = useState(false);

    const isResolved = isSubmitted === 'resolved'

    useEffect(() => {
        const formData = new FormData();
        formData.append('visit_id', visit_id)
        axios.post(`${config.smsUrl}/cmedicationround/inpatient_triage_metrics`, formData).then(res => {
            const data = res.data;
            const dt = data ? data : [];
            setPatientTriage(dt)
        }).catch(err => {
            errorMessages(err, null, actions)
        })
    }, [isResolved])

    const closeSnackbar = () =>{
        actions.snackbarActions.hideSnackbar()
    };


    const {openBar, type, message} = snackbar;

    const recordedTriage = (
        <React.Fragment>
            <Card className='p-3 mt-3'>
                <RecordedTriage {...{actions, patientTriage, setPatientTriage, visit_id,
                    patient_number,isSubmitted, setIsSubmitted}}/>
            </Card>
            <button type='button' onClick={()=>setOpenDialog(true)} className='btn btn-sm sms-btn mt-2'>Add Triage</button>
        </React.Fragment>

    )

    const recordTriage = (
        <RecordTriage {...{actions, patient_number, visit_id,isSubmitted, setIsSubmitted, setOpenDialog}}/>
    )

    return (
        <div className="journals">
            <PageTitle title="Triage"/>
            <SubHeader
                title="Doctor"
                subTitle="Triage"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <CustomDialog title='Record triage' open={openDialog} handleClose={() => setOpenDialog(false)}
                          maxWidth='md'>
                {recordTriage}
            </CustomDialog>
            <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <div style={{padding: '12px 16px'}}>
                    <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                    {patientTriage.length > 0 ? recordedTriage : recordTriage}
                </div>
            </ObGynSidebar>
        </div>
    )
}


function mapStateToProps(state) {
    const {snackbar} = state
    return {snackbar}

}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(GynAndObsTriage);